import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=4972cf82"
import script from "./AppNavigation.vue?vue&type=script&lang=ts"
export * from "./AppNavigation.vue?vue&type=script&lang=ts"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=4972cf82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports